import * as React from "react";
import { forwardRef } from "react";
const SvgBackIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 11, height: 16, viewBox: "0 0 11 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M10 15L2 8L10 1", stroke: "#08B6AB", strokeWidth: 2, strokeLinecap: "round" }));
const ForwardRef = forwardRef(SvgBackIcon);
export { ForwardRef as ReactComponent };
